import React, {useEffect} from 'react';
import {useHistory, Link} from 'react-router-dom';
import {connect, useDispatch} from 'react-redux';
import {message, Menu} from 'antd';
import {useLocation} from 'react-router-dom';

import {
  useAuth,
  useInstance,
  usePrevious,
  useAutoTabLoginLogout,
  useWindowWidth,
} from 'core/hooks';
import {ErrorPage, ErrorBoundary} from 'mui-core';
import {FloatingHeader, FlashMessage, GlobalSearch} from 'core/components';

import {Login} from './modules';
import Routes from './Routes';

import {MainMenu, ForEmployerMenu, ignoreList} from 'config';
import {fetchUserData} from 'redux/modules/profile';
import {getMessage, getLang} from 'redux/modules/general';

import './App.less';
import {useTheme} from '@mui/material/styles';
import {LocalizationProvider} from '@mui/x-date-pickers';
import {AdapterMoment} from '@mui/x-date-pickers/AdapterMoment';
import {Box, useMediaQuery, useScrollTrigger} from '@mui/material';
import {AppHeader, MenuBar, AppFooter, PageLoader} from 'mui-core';
import {openLoginScreen} from 'redux/modules/auth';
import PartnersMenu from 'mui-core/AppHeader/PartnersMenu';

//Toast Message configuration
message.config({
  maxCount: 1,
});

const AppHeaderContent = ({
  MainMenu,
  displayMenuBar,
  defaultMenuSelectedKey,
}) => {
  const theme = useTheme();
  const {location: {pathname = ''} = {}} = useHistory();
  const desktopDevice = useMediaQuery(theme.breakpoints.up('md'));
  // const trigger = useScrollTrigger({
  //   disableHysteresis: true,
  //   threshold: 40,
  // });
  // const movedUp = useScrollTrigger({});

  return (
    <>
      {/* <PartnersMenu
        movedUp={movedUp}
        menuBarOnHide={displayMenuBar ? trigger : true}
      /> */}
      <AppHeader
        MainMenu={ignoreList.includes(pathname) ? ForEmployerMenu : MainMenu}
        displayMenuBar={displayMenuBar}
        // movedUp={displayMenuBar ? movedUp : true}
        defaultMenuSelectedKey={defaultMenuSelectedKey}
        menuBarOnHide={displayMenuBar ? true : true}
      />
      {/* {displayMenuBar && desktopDevice && (
        <MenuBar
          movedUp={!movedUp}
          MainMenu={MainMenu}
          menuBarOnHide={trigger}
          defaultMenuSelectedKey={defaultMenuSelectedKey}
        />
      )} */}
    </>
  );
};

const App = ({fetchUserData, flashMessage, lang}) => {
  const WINDOW = window;
  let displayMenuBar = false;
  // Generic Hooks
  useAutoTabLoginLogout();
  useWindowWidth();
  const {request, error, data, isCriminalJustice} = useInstance();
  const [token, user] = useAuth();
  const prevState = usePrevious({token});

  const navigationMenu = !isCriminalJustice
    ? MainMenu
    : MainMenu.filter(
        item =>
          item?.key !== 'search_events' &&
          item?.key !== 'who-is-hiring' &&
          item?.key !== 'talent-exchange' &&
          item?.key !== 'apprenticeships',
      );

  let defaultMenuSelectedKey = [];
  const {message: customMessage, displayMessage} = flashMessage;
  const history = useHistory();
  const dispatch = useDispatch();
  const {
    location,
    location: {pathname, search},
  } = history;
  let dynamicClassName = 'homepage';
  let hideHeaderFooter = false,
    hideGlobalSearch = false;

  if (pathname) {
    //dynamicClassName = pathname.replace(/[/]/g, ' ');
    dynamicClassName = pathname.split('/')[1] || 'homepage';
    if (pathname.includes('/profile')) {
      hideHeaderFooter = true;
      hideGlobalSearch = true;
    }

    navigationMenu.forEach(({path, key, children, subTabs = false}) => {
      let PATH = path;
      if (path.includes('?')) {
        const idx = path.indexOf('?');
        PATH = PATH.substring(0, idx);
      }
      const excludedPaths = [
        'dashboard',
        'go-survey',
        'resume-builder',
        'career-details',
        'program-details',
        'communities/',
        'companies/',
      ]; // Add all paths to exclude
      const shouldDisplayMenuBar =
        !excludedPaths.some(path => pathname.includes(path)) &&
        !search.includes('?');

      if (shouldDisplayMenuBar) {
        displayMenuBar = true;
      } else {
        displayMenuBar = false;
      }

      if (children && children.length > 0 && pathname.includes(PATH)) {
        displayMenuBar = true;
        defaultMenuSelectedKey = [pathname.split('/')[2], path];
      }
      if (PATH === pathname && !search.includes('?event_id')) {
        displayMenuBar = true;
        defaultMenuSelectedKey = [key];
      }
      if (subTabs && pathname.includes(PATH)) {
        defaultMenuSelectedKey = [key];
      }
    });
  }

  const searchParams = new URLSearchParams(search);
  const loginParam = searchParams.get('login');
  const signupParam = searchParams.get('signup');

  // WINDOW.dataLayer.push({event: 'pageview'});

  useEffect(() => {
    if ((!prevState || (prevState && !prevState.token)) && token) {
      fetchUserData();
    }
  }, [fetchUserData, token]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    document.documentElement.lang = 'en';
  }, [lang]);

  useEffect(() => {
    if (loginParam) {
      dispatch(openLoginScreen({screen: 'signin'}));
    }
    if (signupParam) {
      dispatch(openLoginScreen({screen: 'signup'}));
    }
  }, [loginParam]); // eslint-disable-line react-hooks/exhaustive-deps

  // checking for valid instance
  if (!request && (error || !(data?.msg || data?.institution_id))) {
    if (error || !(data?.msg || data?.institution_id)) {
      return request ? (
        <PageLoader />
      ) : (
        <ErrorPage
          list={null}
          pageRefresh={true}
          heading='Oops! An error occurred'
          subHeading='We are constantly working to improve your GoEducate experience and apologize for any inconvenience with this disruption. Please refresh your browser to view the latest site version.'
        />
      );
    }
  }

  return (
    <Box
    // displaySplash body={{request, data}}
    >
      {displayMessage && customMessage && (
        <FlashMessage message={customMessage} />
      )}

      {/* Need to check instance first */}

      {request && <PageLoader />}

      {!request && data && (
        <ErrorBoundary
          typeOfUi='fullPage'
          nameOfComponent='root-of-application'>
          <Box className={`App ${lang}`}>
            {/* <FloatingHeader data={data} hideHeaderFooter={hideHeaderFooter}>
              {!hideGlobalSearch && <GlobalSearch floatingHeader />}
            </FloatingHeader> */}
            {!hideGlobalSearch && (
              <AppHeaderContent
                MainMenu={navigationMenu}
                displayMenuBar={displayMenuBar}
                defaultMenuSelectedKey={defaultMenuSelectedKey}
              />
            )}
            {/* {displayMenuBar && (
              <div className='mob_home_prog_menu'>
                <Menu
                  mode='horizontal'
                  className='home_prog_menu contentContainer'
                  selectedKeys={defaultMenuSelectedKey}>
                  {MainMenu.map(({key, label, path}) => (
                    <Menu.Item key={key}>
                      <Link to={path}> {label} </Link>
                    </Menu.Item>
                  ))}
                </Menu>
              </div>
            )} */}
            <Box sx={{marginTop: 'calc(64px + 50px)'}}>
              <LocalizationProvider dateAdapter={AdapterMoment}>
                <Routes />
              </LocalizationProvider>
              {!hideHeaderFooter && <AppFooter data={data} />}
            </Box>
            <Login />
          </Box>
        </ErrorBoundary>
      )}
      {/* <div>404 Error window if no instance available..</div> */}
    </Box>
  );
};

const mapStateToProps = state => ({
  flashMessage: getMessage(state),
  lang: getLang(state),
});

export default connect(mapStateToProps, {fetchUserData})(App);
